module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-mastic-004-1200x2490.01ff1a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-mastic-004-1200x2490.jpg
// module id = 1097
// module chunks = 37